import styled from "styled-components";

export const UndrawContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-height: 190px;
    font-size: 1.5em;
    text-align: center;
    margin: 0 0 1em 0;
    max-width: 100%;
    overflow: hidden;

    @media only screen and (max-width: 800px) {
        height: 125px;
        font-size: 1.3em;
    }
`;
